import MathUtils from './math.es6';

/**
 * @classdesc 配列系のユーティリティクラス
 */
export default class ArrUtils {

    /**
     * 数値の配列に重複しない乱数を1つ追加して返す
     * @param {number} min - 生成する乱数の最小値
     * @param {number} max - 生成する乱数の最大値
     * @param {number[]} numArr - 元の数値配列
     * @returns {number[]} 重複しない乱数を追加した配列
     */
    static getAddNewNumArr(min, max, [...numArr] = []) {
        while (true) {
            const num = MathUtils.getRandom(min, max);
            if (numArr.includes(num)) continue;
            numArr.push(num);
            break;
        }

        return numArr;
    }

    /**
     * 配列をシャッフルして返す
     * @template T
     * @param {T[]} arr - シャッフル対象の配列
     * @returns {T[]} シャッフルされた配列
     */
    static getShuffleArr([...arr]) {
        for (let i = arr.length - 1; i >= 0; i--) {
            const j = Math.floor(Math.random() * (i + 1));
            [arr[i], arr[j]] = [arr[j], arr[i]];
        }

        return arr;
    }

    /**
     * 日付の文字列配列を昇順／降順で並び替え
     * @param {string[]} dateArr - 日付文字列（YYYY-MM-DDなど）の配列
     * @param {'asc'|'desc'} [order='asc'] - 並び順（昇順：'asc'／降順：'desc'）
     * @returns {string[]} 並び替えた日付配列
     */
    static getSortDateArr([...dateArr], order = 'asc') {
        const compare = order === 'asc'
            ? (a, b) => new Date(a) - new Date(b)
            : (a, b) => new Date(b) - new Date(a);

        return dateArr.sort(compare);
    }

    /**
     * 数値配列を昇順／降順で並び替え
     * @param {number[]} numArr - 数値の配列
     * @param {'asc'|'desc'} [order='asc'] - 並び順（昇順：'asc'／降順：'desc'）
     * @returns {number[]} 並び替えた数値配列
     */
    static getSortNumArr([...numArr], order = 'asc') {
        const compare = order === 'asc'
            ? (a, b) => a - b
            : (a, b) => b - a;

        return numArr.sort(compare);
    }
}
